import { ProviderType, TrackingEvent } from '../types';
import { addToCartSuccessAdapter } from './addToCartAdapters';
import { checkoutClickAdapter, checkoutResultAdapter } from './checkoutAdapters';
import { goodDetailViewAdapter } from './goodDetailViewAdapter';
import { loginAdapter } from './loginAdapters';
import { createOrderSuccessAdapter, purchaseSuccessAdapter } from './purchaseAdapter';
import { signupAdapter } from './signupAdapters';

// 事件适配器函数类型定义
export type EventAdapter = (
  data: any,
  provider: ProviderType,
  eventId?: string, // 统一的事件 ID
) => TrackingEvent | TrackingEvent[] | null;

/**
 * 事件适配器注册表
 */
export const eventAdapters: Record<string, EventAdapter> = {
  'checkout.click': checkoutClickAdapter,
  'checkout.result': checkoutResultAdapter,
  'purchase.success': purchaseSuccessAdapter,
  'addToCart.success': addToCartSuccessAdapter,
  'createorder.success': createOrderSuccessAdapter,
  goodDetailView: goodDetailViewAdapter,
  'signup.success': signupAdapter,
  'login.success': loginAdapter,
};

/**
 * 获取事件适配器
 */
export function getEventAdapter(eventType: string): EventAdapter | null {
  return eventAdapters[eventType] || null;
}
